// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Study } from './study';
import {
    StudyFromJSON,
    StudyFromJSONTyped,
    StudyToJSON,
    StudyToJSONTyped,
} from './study';

/**
 * 
 * @export
 * @interface DaeStudyDetailResponse
 */
export interface DaeStudyDetailResponse {
    /**
     * 
     * @type {Study}
     * @memberof DaeStudyDetailResponse
     */
    study: Study;
}

/**
 * Check if a given object implements the DaeStudyDetailResponse interface.
 */
export function instanceOfDaeStudyDetailResponse(value: object): value is DaeStudyDetailResponse {
    if (!('study' in value) || value['study'] === undefined) return false;
    return true;
}

export function DaeStudyDetailResponseFromJSON(json: any): DaeStudyDetailResponse {
    return DaeStudyDetailResponseFromJSONTyped(json, false);
}

export function DaeStudyDetailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DaeStudyDetailResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'study': StudyFromJSON(json['study']),
    };
}

export function DaeStudyDetailResponseToJSON(json: any): DaeStudyDetailResponse {
    return DaeStudyDetailResponseToJSONTyped(json, false);
}

export function DaeStudyDetailResponseToJSONTyped(value?: DaeStudyDetailResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'study': StudyToJSON(value['study']),
    };
}
